import {IServiceFactory} from "../../service-factory.interface";
import {NullableNumber, NullableString} from "../../../types/nullable-types";
import {PassengerTypeBase} from "./passenger-type-base";
import {PassengerTypeCodesEnum} from "../passenger-type-codes.enum";

class InfantBase extends PassengerTypeBase {

    get description(): string {
        return this.services.language.translate('Infant');
    }

    getMinimumAge(): number {
        return 0;
    }

    protected _getMaximumAge(): NullableNumber {
        return 2;
    }

    get isAdult(): boolean {
        return false;
    }

    get isChild(): boolean {
        return false;
    }

    get isInfant(): boolean {
        return true;
    }

    get canBeMadePrimaryContact(): boolean {
        return false;
    }

    get implicitTitleValue(): NullableString {
        return 'CHD';
    }

    get isDog(): boolean {
        return false;
    }

    get isDateOfBirthMandatory(): boolean {
        return true;
    }
}

export class Infant extends InfantBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.Infant);
    }

}

export class InfantOld extends InfantBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.InfantOld);
    }
}